import {IconButton} from '@wandb/components';
import React from 'react';

import {type SettingLevel} from '../../../../services/analytics/workspaceSettingsEvents';

export type ResetSettingButtonProps = {
  className?: string;
  isEnabled: boolean;
  settingLevel: SettingLevel;
  onButtonClick: () => void;
};

export const ResetSettingButton = ({
  className,
  isEnabled,
  settingLevel,
  onButtonClick,
}: ResetSettingButtonProps) => {
  if (settingLevel === 'workspace') {
    return null;
  }

  if (!isEnabled) {
    return <div className="h-32 w-32" />;
  }

  return (
    <div className={className}>
      <IconButton
        icon="reset"
        onPress={onButtonClick}
        size="md"
        tooltip={{children: 'Reset'}}
        variant="ghost"
        aria-label="Reset"
      />
    </div>
  );
};
